import { schema } from 'normalizr';

const slidesSchema = new schema.Entity('script_templates');

export default {
  slidesSchema,
};
